import { render, staticRenderFns } from "./BasePageComponent.vue?vue&type=template&id=223668ac&scoped=true&"
import script from "./BasePageComponent.vue?vue&type=script&lang=js&"
export * from "./BasePageComponent.vue?vue&type=script&lang=js&"
import style0 from "./BasePageComponent.vue?vue&type=style&index=0&id=223668ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223668ac",
  null
  
)

export default component.exports